import React from 'react';
import { StyleSheet, useWindowDimensions } from 'react-native';
import { useStyle } from 'react-native-style-utilities';

import { BodyText } from '../../Text';

// NOTE: mirrors the subset of the `headerTitle` render-prop args that
// `expo-router`'s `navigation.setOptions`
type HeaderTitleProps = Readonly<{
  children?: string;
  tintColor?: string;
}>;

export const HeaderTitle = ({ children, tintColor }: HeaderTitleProps) => {
  const { width: screenWidth } = useWindowDimensions();

  // NOTE: We limit header title width to prevent other possible header components from being covered.
  const headerMaxWidth = screenWidth - SCREEN_HEADER_CONTROLS_SAFE_AREA;

  const dynamicStyle = useStyle(
    () => ({ color: tintColor, maxWidth: headerMaxWidth }),
    [tintColor, headerMaxWidth],
  );

  return (
    <BodyText
      testID="sg-scrollview.header.title"
      sizeMatch={['18', '22', '24']}
      style={[styles.headerTitle, dynamicStyle]}
      numberOfLines={2}
      maxFontSizeMultiplier={1.1}
    >
      {children}
    </BodyText>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const SCREEN_HEADER_CONTROLS_SAFE_AREA = 130;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  headerTitle: {
    textAlign: 'center',
  },
});
